import LegalPage from '@components/legal-page';
import { createLegalPageStaticProps } from '@components/legal-page/static-props';
import type { LegalPageProps } from '@components/legal-page/static-props';

const PRIVACY_PAGE_SLUG = 'privacy-policy';

const Privacy = ({ page }: LegalPageProps) => {
  if (!page) return null;
  return <LegalPage page={page} />;
};

export const getStaticProps = createLegalPageStaticProps(PRIVACY_PAGE_SLUG);

export default Privacy;
